import React, { useState } from 'react';

import vet1 from '../projectitems/Projelerimiz/vetklinik/WhatsApp Image 2026-02-26 at 11.15.39.jpeg';
import vet2 from '../projectitems/Projelerimiz/vetklinik/WhatsApp Image 2026-02-26 at 11.14.17 (2).jpeg';
import vet3 from '../projectitems/Projelerimiz/vetklinik/WhatsApp Image 2026-02-26 at 11.14.17 (1).jpeg';
import vet4 from '../projectitems/Projelerimiz/vetklinik/WhatsApp Image 2026-02-26 at 11.14.16.jpeg';
import vet5 from '../projectitems/Projelerimiz/vetklinik/WhatsApp Image 2026-02-26 at 11.14.17.jpeg';

import estetik1 from '../projectitems/Projelerimiz/estetikklinik/WhatsApp Image 2026-02-26 at 11.42.31.jpeg';
import estetik2 from '../projectitems/Projelerimiz/estetikklinik/WhatsApp Image 2026-02-26 at 11.42.31 kopyası.jpeg';
import estetik3 from '../projectitems/Projelerimiz/estetikklinik/WhatsApp Image 2026-02-26 at 11.42.31 (1).jpeg';
import estetik4 from '../projectitems/Projelerimiz/estetikklinik/WhatsApp Image 2026-02-26 at 11.42.31 (2).jpeg';
import estetik5 from '../projectitems/Projelerimiz/estetikklinik/WhatsApp Image 2026-02-26 at 11.42.31 (3).jpeg';
import estetik6 from '../projectitems/Projelerimiz/estetikklinik/WhatsApp Image 2026-02-26 at 11.42.31 (4).jpeg';
import estetik7 from '../projectitems/Projelerimiz/estetikklinik/WhatsApp Image 2026-02-26 at 11.42.32.jpeg';

import wellness1 from '../projectitems/Projelerimiz/wellnesmerkezi/WhatsApp Image 2026-02-26 at 10.24.44.jpeg';
import wellness2 from '../projectitems/Projelerimiz/wellnesmerkezi/WhatsApp Image 2026-02-26 at 10.25.29.jpeg';
import wellness3 from '../projectitems/Projelerimiz/wellnesmerkezi/WhatsApp Image 2026-02-26 at 10.25.00.jpeg';
import wellness4 from '../projectitems/Projelerimiz/wellnesmerkezi/WhatsApp Image 2026-02-26 at 10.25.58.jpeg';
import wellness5 from '../projectitems/Projelerimiz/wellnesmerkezi/WhatsApp Image 2026-02-26 at 10.24.21.jpeg';

import sosyal1 from '../projectitems/Projelerimiz/sosyalmerkez/WhatsApp Image 2026-02-26 at 11.42.02.jpeg';
import sosyal2 from '../projectitems/Projelerimiz/sosyalmerkez/WhatsApp Image 2026-02-26 at 11.42.03.jpeg';
import sosyal3 from '../projectitems/Projelerimiz/sosyalmerkez/WhatsApp Image 2026-02-26 at 11.42.03 (1).jpeg';
import sosyal4 from '../projectitems/Projelerimiz/sosyalmerkez/WhatsApp Image 2026-02-26 at 11.42.03 (2).jpeg';
import sosyal5 from '../projectitems/Projelerimiz/sosyalmerkez/WhatsApp Image 2026-02-26 at 11.42.03 (3).jpeg';

const projects = [
    {
        title: 'Veteriner Klinik',
        cover: vet5,
        images: [vet1, vet2, vet3, vet4, vet5],
    },
    {
        title: 'Estetik Klinik',
        cover: estetik1,
        images: [estetik1, estetik2, estetik3, estetik4, estetik5, estetik6, estetik7],
    },
    {
        title: 'Wellness Merkezi',
        cover: wellness1,
        images: [wellness1, wellness2, wellness3, wellness4, wellness5],
    },
    {
        title: 'Sosyal Merkez',
        cover: sosyal1,
        images: [sosyal1, sosyal2, sosyal3, sosyal4, sosyal5],
    },
];

const Press = () => {
    const [activeProject, setActiveProject] = useState(null);
    const [lightboxIdx, setLightboxIdx] = useState(null);

    const openGallery = (project) => setActiveProject(project);
    const closeGallery = () => { setActiveProject(null); setLightboxIdx(null); };

    const openLightbox = (idx) => setLightboxIdx(idx);
    const closeLightbox = () => setLightboxIdx(null);

    const prevImage = () => {
        if (activeProject && lightboxIdx !== null) {
            setLightboxIdx((lightboxIdx - 1 + activeProject.images.length) % activeProject.images.length);
        }
    };
    const nextImage = () => {
        if (activeProject && lightboxIdx !== null) {
            setLightboxIdx((lightboxIdx + 1) % activeProject.images.length);
        }
    };

    return (
        <section className="press" id="uygulamalar">
            <div className="press__container">
                <div className="press__header">
                    <p className="section-eyebrow">Projelerimiz</p>
                    <h2 className="section-title press__title">ÇALIŞMALARIMIZ</h2>
                    <p className="press__desc">
                        Mimarlık, iç mimarlık ve dekorasyon alanında tamamladığımız projelerden seçmeler. Her mekan, müşterilerimizin vizyonuyla şekillenen özgün bir hikaye taşır.
                    </p>
                </div>

                {!activeProject ? (
                    <div className="projects__grid">
                        {projects.map((p) => (
                            <button
                                className="project-card"
                                key={p.title}
                                onClick={() => openGallery(p)}
                            >
                                <img src={p.cover} alt={p.title} className="project-card__img" />
                                <div className="project-card__overlay">
                                    <h3 className="project-card__title">{p.title}</h3>
                                    <span className="project-card__count">{p.images.length} Fotoğraf</span>
                                </div>
                            </button>
                        ))}
                    </div>
                ) : (
                    <div className="project-gallery">
                        <button className="project-gallery__back" onClick={closeGallery}>
                            ← Tüm Projeler
                        </button>
                        <h3 className="project-gallery__title">{activeProject.title}</h3>
                        <div className="project-gallery__grid">
                            {activeProject.images.map((img, idx) => (
                                <button
                                    className="project-gallery__item"
                                    key={idx}
                                    onClick={() => openLightbox(idx)}
                                >
                                    <img src={img} alt={`${activeProject.title} ${idx + 1}`} />
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {lightboxIdx !== null && activeProject && (
                <div className="lightbox" onClick={closeLightbox}>
                    <div className="lightbox__content" onClick={(e) => e.stopPropagation()}>
                        <button className="lightbox__close" onClick={closeLightbox}>✕</button>
                        <button className="lightbox__nav lightbox__nav--prev" onClick={prevImage}>‹</button>
                        <img
                            src={activeProject.images[lightboxIdx]}
                            alt={`${activeProject.title} ${lightboxIdx + 1}`}
                            className="lightbox__img"
                        />
                        <button className="lightbox__nav lightbox__nav--next" onClick={nextImage}>›</button>
                        <span className="lightbox__counter">
                            {lightboxIdx + 1} / {activeProject.images.length}
                        </span>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Press;
